import React, { memo } from 'react';
import { useLoadingState } from '../../hooks/useLoadingState';
import LoadingSpinner from './LoadingSpinner';
import LoadingPage from './LoadingPage';

/**
 * Centralized loading manager component
 * Handles all loading states consistently across the app
 */
const LoadingManager = memo(({ 
  children, 
  showGlobalLoader = true,
  loadingMessage = "Loading...",
  className = ""
}) => {
  const { isAnyLoading, getLoadingState } = useLoadingState();

  // Show global loading overlay if any loading is active
  if (showGlobalLoader && isAnyLoading) {
    return (
      <div className={`fixed inset-0 z-50 bg-white/90 backdrop-blur-sm flex items-center justify-center ${className}`}>
        <div className="text-center">
          <LoadingSpinner size="xl" color="blue" />
          <p className="mt-4 text-lg font-medium text-gray-700">{loadingMessage}</p>
          
          {/* Show specific loading indicators */}
          <div className="mt-4 space-y-2 text-sm text-gray-500">
            {getLoadingState('navigation') && (
              <p>Navigating to your lesson...</p>
            )}
            {getLoadingState('data') && (
              <p>Loading your progress...</p>
            )}
            {getLoadingState('media') && (
              <p>Loading audio and images...</p>
            )}
          </div>
        </div>
      </div>
    );
  }

  return children;
});

LoadingManager.displayName = 'LoadingManager';

export default LoadingManager;




